import moment from 'moment';
import { workWeek } from '../constants/Constant';
import Utility from '../utility/Utility';
import { COLUMN_CODE, TableManger, TABLES } from './TableManger';
import { TENANT, TenantService } from './TenantManagerService';

export class PayScheduleManager {
    static processDataForSubmit(field, defaultData){
        let responseData = {
            finalData: defaultData,
            isValid: true
        };

        switch(field['columnCode']){
            case "firstPayDate":
                responseData.finalData[field['columnCode']] = moment(field['value']).format();
                break;
            case "workWeek":
                responseData.finalData[field['columnCode']] =  PayScheduleManager.getWorkWeek(field['value']);
                break;
            case "payDay":
                responseData.finalData[field['columnCode']] = field['value'];
                if(field['value'] == "lastWorkingDayMonth") {
                    responseData.finalData['firstPayDate'] = moment().endOf('month').format("YYYY-MM-DD")
                } else {
                    responseData.finalData['firstPayDate'] = moment().format(`YYYY-MM-${(field['value'] < 10 ? "0"+field['value'] : field['value'] )}`)
                }

                break;
            default:
                responseData.finalData[field['columnCode']] = field['value'];
                break;
        }
        if(responseData.finalData['id'] && responseData.finalData['id'] != ""){
            responseData.finalData['_id'] = (responseData.finalData['id'] && responseData.finalData['id'] != "") ? responseData.finalData['id'] : ""
        }
        return responseData;
    }
    static getWorkWeek(value){
        if(value) {
            let week = moment.weekdays().map(ele=>{
                return ele.toLocaleLowerCase()
            })
            let selectedWeeek = value.map(obj=>{
                return week.indexOf(obj.value);
            })
            return selectedWeeek;
        } else {
            return PayScheduleManager.getWorkingDays();
        }
    }

    static getDefaultValues(values = {}) {
        return {
            // [TableManger.getColumnId(TABLES.ADD_PAYROLL, COLUMN_CODE.ADD_PAYROLL.PAY_SCHEDULE)] : [0],
            [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_PERIOD)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_WEEK)]: PayScheduleManager.getWorkingDays(),
            [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DAY)]: [0],
            [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.PAY_DATE)]: moment().endOf('month').toDate(),
            // [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_PERIOD_FROM)]:moment().toDate(),
            // [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.WORK_PERIOD_TO)]:moment().toDate(),
            [TableManger.getColumnId(TABLES.ADD_PAY_SCHEDULE, COLUMN_CODE.PAY_SCHEDULE_LIST.IS_APPLICABLE_TO_ALL)]: [1],
            ...values
        }
    }
    static getWorkingDays() {
      let workWeekIds = [];
      let tenantWorkWeek = TenantService.get(TENANT.TENANT_WORK_WEEK)
      tenantWorkWeek.forEach(ele=>{
        if(ele.isWorkingDay) {
          let ind = workWeek.findIndex(w=> w.name.toLowerCase()==ele.day.toLowerCase())
          if(ind != -1) {
            workWeekIds.push(parseInt(workWeek[ind].id))
          }
        }
      })
      return workWeekIds
    }
    static workWeekDaysValid(data) {
      let isWorkingDayMismatch = false;
      let workingIds = PayScheduleManager.getWorkingDays();
      data.forEach(ele=>{
          let ind = workingIds.findIndex(res=> res==ele)
          if(ind == -1 ){
              isWorkingDayMismatch = true;
          }
      })
      return isWorkingDayMismatch;
    }

    static getPayScheduleDefaultValues(values = {}, customFields) {
        let group = {
            "payscheduleName": values['name'],
            "location": values["location"],
            "payPeriod":values["payPeriod"],
            "applicableToAll": values["isForAllUsers"],
            "employees":values["employees"],
            "_id":values["id"],
            "payDay": values["payDay"]
          }
          group = PayScheduleManager.updateCustomFieldValues(values, customFields, group)
        return group;
    }

    static updateCustomFieldValues(values, customFieldsData, group) {
        const { customFields } = customFieldsData || [];
        const customFieldFormValues = values?.customFields || [];
        customFields?.forEach((c) => {
            const formValues = customFieldFormValues.find((x) => x.fieldId === c.id);
            if(!Utility.isEmptyObject(formValues)) {
                switch (c.type) {
                    case "text":
                        if(formValues?.fieldValue) {
                            group[c.id] = formValues?.fieldValue[0];
                        }
                        break;
                    case "multiselect":
                        group[c.id] = formValues?.fieldValue;
                        break;
                
                    default:
                        if(formValues?.fieldValue) {
                            group[c.id] = formValues?.fieldValue[0];
                        }
                        break;
                }
            }
        });
        return group;
    }

    static getAddPayscheduleDefaultValues(customFieldsData, values = {}) {
        let group = {
            "applicableToAll": { id: "false", name: "No" },
            "location": [{"id":"", name : "None"}],
            ...values
        }
        group = PayScheduleManager.updatePayrunWithCustomFieldDefaultValues(customFieldsData, group);
        return group;
    }

    static updatePayrunWithCustomFieldDefaultValues(customFieldsData, group) {
        const { customFields } = customFieldsData;
        customFields?.forEach((c) => {
                switch (c.type) {
                    case "text":
                        if(c?.defaultValue) {
                            group[c.id] = c?.defaultValue[0];
                        }
                        break;
                    case "multiselect":
                        const defaultValue = [];
                        c?.defaultValue.forEach((d) => {
                            let index = c.possibleValues.findIndex((p) => p === d);
                            if(index != -1) {
                                defaultValue.push(index);
                            }
                        })

                        group[c.id] = defaultValue;
                        break;
                
                    default:
                        group[c.id] = c?.defaultValue[0];
                        break;
                }
        });
        return group;
    }

}